export default function TypeaheadBaseController(
    $scope,
    flightsApiService
) {
    'ngInject';

    $scope.airports = [];

    $scope.getLocation = function(searchString) {
        $scope.airports = [];

        if (searchString && searchString.length < 2) {
            return $scope.airports;
        }

        /**
         * Expected request data
         */
        const requestData = {
            params: {searchPattern: searchString},
            noSpinner: true,
        };

        return flightsApiService.searchLocation(requestData);
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/flights/typeaheadBaseCtrl.js